(() => {
  'use strict';

  const pushEvent = (name, detail = {}) => {
    const payload = { event: name, ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('kratzbaumwerft:analytics', { detail: payload }));
  };

  const sticky = document.querySelector('[data-kw-v7-sticky]');
  if (sticky) {
    let stickyFrame = 0;
    const updateSticky = () => {
      stickyFrame = 0;
      sticky.dataset.visible = window.scrollY > 520 ? 'true' : 'false';
    };
    const scheduleStickyUpdate = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(updateSticky);
    };
    if (window.scrollY > 520) {
      window.requestAnimationFrame(updateSticky);
    }
    window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
  }

  document.addEventListener('click', (event) => {
    const configuratorLink = event.target.closest('a[href*="/pages/konfigurator"]');
    if (configuratorLink) {
      pushEvent('kw_configurator_cta', {
        placement: configuratorLink.dataset.kwV7Cta || configuratorLink.closest('[class*="kw-v7"]')?.className || 'site',
        destination: configuratorLink.getAttribute('href')
      });
    }
  });

  document.addEventListener('kwc:step', (event) => pushEvent('kw_configurator_step', event.detail || {}));
  document.addEventListener('kwc:submitted', (event) => pushEvent('kw_configurator_submitted', event.detail || {}));
  document.addEventListener('kwc:error', (event) => pushEvent('kw_configurator_error', event.detail || {}));

  const normalizeLegalNoticeLinks = () => {
    document.querySelectorAll('a[href*="kratzbaumwerft.myshopify.com/policies/legal-notice"]').forEach((link) => {
      link.setAttribute('href', '/policies/legal-notice');
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  };

  window.addEventListener('load', () => {
    normalizeLegalNoticeLinks();
    window.setTimeout(normalizeLegalNoticeLinks, 1500);
  }, { once: true });

})();
